import React from "react";

export function Prestation() {
  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#FF7954]/5 to-[#FCDEBE]/10"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div
          className="bg-[#0A0A0A]/80 rounded-2xl p-12 border-2 border-[#FF7954]
                      transform hover:-translate-y-2 transition-all duration-300"
        >
          <h2 className="text-4xl font-bold text-[#FF7954] text-center mb-16 relative">
            La Prestation
          </h2>

          <div className="bg-[#0A0A0A]/80 rounded-xl p-6 sm:p-8 border-2 border-[#FF7954] relative">
            <h3 className="text-xl sm:text-2xl font-semibold text-white mb-4 sm:mb-6 text-center">
              Comment ça marche ?
            </h3>
            <ul className="space-y-4 text-white text-sm sm:text-lg leading-relaxed">
              <li className="flex items-start">
                <span className="text-[#FF7954] font-bold mr-2 flex-shrink-0">
                  1.
                </span>
                <span>
                  Vous prenez contact avec notre équipe pour réserver votre
                  place de parking, que ce soit pour un box individuel couvert
                  ou une place extérieure sécurisée.
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-[#FF7954] font-bold mr-2 flex-shrink-0">
                  2.
                </span>
                <span>
                  Le jour de votre départ, vous vous présentez à notre parking
                  situé à 10 minutes de l'aeroport de Beauvais-Tillé.
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-[#FF7954] font-bold mr-2 flex-shrink-0">
                  3.
                </span>
                <span>
                  Notre service de navette gratuite vous conduit directement à
                  l'aéroport, assurant une transition fluide vers votre vol.
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-[#FF7954] font-bold mr-2 flex-shrink-0">
                  4.
                </span>
                <span>
                  Pendant votre absence, votre véhicule est en sécurité dans
                  notre parking surveillé 24/7. Vous conservez vos clés,
                  garantissant ainsi votre tranquillité d'esprit.
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-[#FF7954] font-bold mr-2 flex-shrink-0">
                  5.
                </span>
                <span>
                  À votre retour, notre navette vous récupère à l'aéroport et
                  vous ramène à votre véhicule. Le paiement s'effectue
                  uniquement à la fin de la prestation, lors de la récupération
                  de votre véhicule.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
